import attack from '../../../request/request'
import { BASIC } from '../../requers_variable'

export default {
  /**
   * 树形数据
   */
  get_tree(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/region/tree`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
    /**
   * 树形数据2
   */
  subject_tree(params) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${BASIC}/subject/region/aduit`,
        data: params,
        success(rep) {
          resolve({
            status: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            status: false,
            code: '',
            msg: err.message
          })
        }
      })
    })
  },
}


// WEBPACK FOOTER //
// ./src/data/basic/region/region.js